declare global {
    interface Window {
        reloadWhole;
    }
}


export class RemoveRenderLine {
    static removeFullyConsumed(epc_id) {
        $(`.asset-${epc_id}`).remove();
        window.reloadWhole();
    }

    static removeManuallyConsumed(id) {
        $(`#table-data-validate-${id}`).remove();
        $(`#table-data-save-${id}`).remove();
        window.reloadWhole();
    }
}
